import React, { type ReactNode } from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ThemedText } from '../themed-text';
import { cn } from '@/utils/cn';
import { Card } from './card';

export interface FormSectionProps {
  /** Ícone da seção, em círculo suave */
  icon?: React.ComponentProps<typeof Ionicons>['name'];
  title: string;
  /** Texto de apoio explicando a seção em linguagem simples */
  description?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Seção de formulário: card com título, ícone e texto de apoio.
 * Agrupa poucos campos por vez para o preenchimento ficar leve.
 */
export function FormSection({ icon, title, description, children, className }: FormSectionProps) {
  return (
    <Card className={cn('gap-4 p-5', className)}>
      <View className="flex-row items-center gap-3">
        {icon ? (
          <View className="h-9 w-9 items-center justify-center rounded-full bg-primary/10 dark:bg-primary">
            <Ionicons className="text-primary dark:text-white" name={icon} size={17} />
          </View>
        ) : null}
        <View className="flex-1 gap-0.5">
          <ThemedText className="font-semibold text-base text-neutral-900">{title}</ThemedText>
          {description ? (
            <ThemedText className="text-xs leading-4 text-neutral-500">{description}</ThemedText>
          ) : null}
        </View>
      </View>
      <View className="gap-1">{children}</View>
    </Card>
  );
}
